import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import {Table, Spin} from 'antd';
import monitorService from "../services/monitor.service";
import _ from 'lodash'

const docTarget = (value, record , index)=> {
    const folderPath = _.get(record, "detail.folderPath");
    if (record && record.detail) {
        let msg = '';
        if (record.action === "view" && (["photoFolders", "videoFolders"].includes(record.module))) {
            if (record.detail.status === 'ok') {
                msg = _.get(record, "detail.folderName", '');
            }
            else{
                msg = 'failed';
            }
        }
        if (record.action === "download" && ( ["docFiles", "photoFiles", "videoFiles", "mapFiles"].includes(record.module))) {
            if (record.detail.status === 'ok') {
                const fileOrigName = _.get(record, "detail.file.originalname", '');
                if ( fileOrigName !== '' ) {
                    msg = folderPath ? folderPath + "/" + fileOrigName : fileOrigName;
                }
                else {
                    msg = _.get(record, "detail.fileName", '');
                }
            }
            else{
                msg = 'failed';
            }
        }
        if (record.action === "view" && (["videoFiles", "mapFiles"].includes(record.module))) {
            if (record.detail.status === 'ok') {
                msg = _.get(record, "detail.fileName", '');
            }
            else{
                msg = 'failed';
            }
        }
        return <span> {msg} </span>;
    }
    return value;
};

const columns = [
    {
        title: 'Creation Date',
        dataIndex: 'creationDate',
        key: 'creationDate',
        sorter: (a, b) => { return a.creationDate.localeCompare(b.creationDate)},
    },
    {
        title: 'IP Address',
        dataIndex: 'clientIP',
        key: 'clientIP',
    },
    {
        title: 'Module',
        dataIndex: 'module',
        key: 'module',
        sorter: (a, b) => {return a.module.localeCompare(b.module)},
    },
    {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        sorter: (a, b) => { return a.action.localeCompare(b.action)},
    },
    {
        title: 'Document Targeted',
        dataIndex: 'detail',
        key: 'detail',
        render: docTarget,
    },

];



class ActivityPublicContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataTablePublic: [],
            loading: true,
            selectedDocumentKey:'',
            selectedDocuments:[],
            selectedTab: '',

        }
    }



    componentDidMount = () => {
        monitorService.getPublicActivities().then((access) => {
            this.setState(() => {
                return {dataTablePublic: access.rows, loading: false};
                console.log(access.rows);
            })
        });
    };

    render() {

        const pagination = {
            total: this.state.count,
            pageSize: 14,
            pageSizeOptions: ['14'],
        }

        return (
                        <Spin spinning={this.state.loading} delay={500}>
                            <Table
                                dataSource={this.state.dataTablePublic}
                                columns={columns}
                                pagination={pagination}
                            />
                        </Spin>
        )
    }
}

export default ActivityPublicContainer
